import { Box } from '@mantine/core';

export type StatusDotTone = 'neutral' | 'positive' | 'attention' | 'negative' | 'info';

export interface StatusDotViewProps {
  tone?: StatusDotTone;
  /** Explicit color override — a Mantine color name or a hex value (e.g. a category color). Takes priority over `tone`. */
  color?: string;
  size?: number;
  label?: string;
}

const TONE_COLOR: Record<StatusDotTone, string> = {
  neutral: 'var(--mantine-color-gray-5)',
  positive: 'var(--mantine-color-teal-6)',
  attention: 'var(--mantine-color-orange-6)',
  negative: 'var(--mantine-color-red-6)',
  info: 'var(--mantine-color-blue-6)',
};

export function StatusDotView({ tone = 'neutral', color, size = 8, label }: StatusDotViewProps) {
  const resolvedColor =
    color == null
      ? TONE_COLOR[tone]
      : color.startsWith('#')
        ? color
        : `var(--mantine-color-${color}-6)`;

  return (
    <Box
      role={label ? 'img' : undefined}
      aria-label={label}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: resolvedColor,
        flexShrink: 0,
      }}
    />
  );
}
